import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { addFoodCategoriesRequest, addFoodCategoriesRequestError, addFoodCategoriesRequestSuccess } from '../../slices/Content/AddFoodCategoriesSlice';

export const AddFoodCategoriesAPI = (data) => {
    return async (dispatch) => {
        try {
            dispatch(addFoodCategoriesRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.addFoodCategories,
                data: data,
            })
            return dispatch(addFoodCategoriesRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(addFoodCategoriesRequestError(_error));
        }
    };
};
